import { api } from "..";

interface CancelOwnCouponsPayload {
  couponIds: string[];
}

export const cancelOwnCoupons = async ({
  couponIds,
}: CancelOwnCouponsPayload) => {
  const res = await api.client.post(`/users-new/coupons/bulk-cancel-self`, {
    couponIds,
  });
  return res.data;
};
